export enum SmoSocketClientEvent {
  connect_front = 'connect_front',
  connect_widget = 'connect_widget',
  update_settings = 'update_settings',
  update_environment = 'update_environment',
  update_run = 'update_run'
}
